import { sleep } from "../sorting/algorithms";
import { NodeI } from "./pathFinding";
const delay=10;

function minDistance(grid:NodeI[][]) {
    let min=Number.MAX_VALUE+1;
    let index:number[]=[];
    grid.forEach(row => {
        row.forEach(node => {
            if (node.distance<min && !node.isVisited && !node.isWall) {
                min=node.distance;
                index=[node.row,node.col];
            }
        });
    });
    return index;
}
function minAstarDistance(grid:NodeI[][],destNode:NodeI) {
    let min=Number.MAX_VALUE+1;
    let index:number[]=[];
    grid.forEach(row => {
        row.forEach(node => {
            let aStarDistance=node.distance+Math.abs(node.row-destNode.row)+Math.abs(node.col-destNode.col);
            if (aStarDistance<min && !node.isVisited && !node.isWall) {
                min=aStarDistance;
                index=[node.row,node.col];
            }
        });
    });
    return index;
}
export async function djikstra(grid:NodeI[][],setchange:Function,speed:number=50,updateStats?:(stats: { nodesVisited?: number; pathLength?: number }) => void) {
    // Find current start position and reset distances
    let startNode: NodeI | null = null;
    grid.forEach(row => {
        row.forEach(node => {
            if (node.isSrc) {
                startNode = node;
                node.distance = 0;
            } else {
                node.distance = Number.MAX_VALUE;
                node.isVisited = false;
                node.isPath = false;
                node.previous = null;
            }
        });
    });
    
    if (!startNode) {
        console.log("No start node found");
        return;
    }
    
    while (true) {
        let index=minDistance(grid);
        if(index.length<1){
            console.log("not success");
            return;
        }
        let i=index[0],j=index[1];
        grid[i][j].isVisited=true;
        setchange(Math.random());
        
        // Update visited count
        if (updateStats) {
            const visitedCount = grid.flat().filter(node => node.isVisited).length;
            updateStats({ nodesVisited: visitedCount });
        }
        
        await sleep(speed);

        let neighbors=[];
        if(i+1<grid.length && !grid[i+1][j].isVisited){
            neighbors.push(grid[i+1][j]);
        }
        if(i-1>=0 && !grid[i-1][j].isVisited){
            neighbors.push(grid[i-1][j]);
        }
        if(j+1<grid[0].length && !grid[i][j+1].isVisited){
            neighbors.push(grid[i][j+1]);
        }
        if(j-1>=0 && !grid[i][j-1].isVisited){
            neighbors.push(grid[i][j-1]);
        }
        if(grid[i][j].isDest){
            let prev=grid[i][j].previous;
            let pathLength = 0;
            while(prev && !prev.isSrc){
                prev.isPath=true;
                prev=prev.previous;
                pathLength++;
                await sleep(speed);
                setchange(Math.random());
            }
            
            // Update path length
            if (updateStats) {
                updateStats({ pathLength: pathLength });
            }
            
            console.log("Success");
            return;
        }
        neighbors.forEach(node => {
            let newDistance=grid[i][j].distance+node.weight;
            if(node.distance>newDistance && !node.isWall){
                node.distance=newDistance;
                node.previous=grid[i][j];
            }
        });
        
    }
}

export async function aStar(grid:NodeI[][],setchange:Function,speed:number=50,updateStats?:(stats: { nodesVisited?: number; pathLength?: number }) => void) {
    // Find current start and end positions and reset distances
    let startNode: NodeI | null = null;
    let destNode: NodeI | null = null;
    
    grid.forEach(row => {
        row.forEach(node => {
            if (node.isSrc) {
                startNode = node;
                node.distance = 0;
            } else if (node.isDest) {
                destNode = node;
            } else {
                node.distance = Number.MAX_VALUE;
                node.isVisited = false;
                node.isPath = false;
                node.previous = null;
            }
        });
    });
    
    if (!startNode || !destNode) {
        console.log("Start or end node not found");
        return;
    }
    
    while (true) {
        let index=minAstarDistance(grid,destNode);
        if(index.length<1){
            console.log("not success");
            return;
        }
        let i=index[0],j=index[1];
        grid[i][j].isVisited=true;
        setchange(Math.random());
        
        // Update visited count
        if (updateStats) {
            const visitedCount = grid.flat().filter(node => node.isVisited).length;
            updateStats({ nodesVisited: visitedCount });
        }
        
        await sleep(speed);

        let neighbors=[];
        if(i+1<grid.length && !grid[i+1][j].isVisited){
            neighbors.push(grid[i+1][j]);
        }
        if(i-1>=0 && !grid[i-1][j].isVisited){
            neighbors.push(grid[i-1][j]);
        }
        if(j+1<grid[0].length && !grid[i][j+1].isVisited){
            neighbors.push(grid[i][j+1]);
        }
        if(j-1>=0 && !grid[i][j-1].isVisited){
            neighbors.push(grid[i][j-1]);
        }
        if(grid[i][j].isDest){
            let prev=grid[i][j].previous;
            let pathLength = 0;
            while(prev && !prev.isSrc){
                prev.isPath=true;
                prev=prev.previous;
                pathLength++;
                await sleep(speed);
                setchange(Math.random());
            }
            
            // Update path length
            if (updateStats) {
                updateStats({ pathLength: pathLength });
            }
            
            console.log("Success");
            return;
        }
        neighbors.forEach(node => {
            let newDistance=grid[i][j].distance+node.weight;
            if(node.distance>newDistance && !node.isWall){
                node.distance=newDistance;
                node.previous=grid[i][j];
            }
        });
        
    }
}